<script setup>
const menuVisible = ref(false);
const route = useRoute();

const props = defineProps({
  showBackToMainPageBar: {
    type: Boolean,
    default: false,
  },
  showAppHeaderMenu: {
    type: Boolean,
    default: true,
  },
});

const isCalculatorVisible = useState('isCalculatorVisible', () => true);
</script>

<template>
  <LazyMenuMobile v-model:visible="menuVisible"/>
  <AppHeaderBar v-if="route.name === 'index'"/>
  <div class="sticky top-0 bg-white shadow-box z-50">
    <BarBackToMainPage v-if="props.showBackToMainPageBar" />
    <Container no-paddings class="relative">
      <AppHeaderMenu v-if="props.showAppHeaderMenu" @hamburgerClick="menuVisible = !menuVisible"/>
      <AppHeaderActionBar :no-switch="true" ref="actionBarRef" />
    </Container>
  </div>
</template>
